import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Testimonial from '../Testimonial/Testimonial';
import Teams from '../Teams/Teams';
import Footer from "../Footer/Footer";
import AboutSectionThreeCarousel from './AboutSectionThreeCarousel';
import './About.css';

// Images
import AboutSectionOneImage from './Images/AboutSectionOneImage.png';
import AboutStoryImageOne from './Images/aboutstory01.jpg';
import AboutStoryImageTwo from './Images/aboutstory02.jpg';
import AboutStoryImageThree from './Images/aboutstory03.jpg';

// Menu Images
import aboutbreakfast01 from './Images/about-breakfast-01.png';
import aboutbreakfast02 from './Images/about-breakfast-02.png';
import aboutbreakfast03 from './Images/about-breakfast-03.png';
import aboutbreakfast04 from './Images/about-breakfast-04.png';
import aboutbreakfast05 from './Images/about-breakfast-05.png';
import aboutlunch01 from './Images/about-lunch-tab-01.png';
import aboutlunch02 from './Images/about-lunch-tab-02.png';
import aboutlunch03 from './Images/about-lunch-tab-03.png';
import aboutlunch04 from './Images/about-lunch-tab-04.png';
import aboutlunch05 from './Images/about-lunch-tab-05.png';
import aboutdinner01 from './Images/about-dinner-tab-01.png';
import aboutdinner02 from './Images/about-dinner-tab-02.png';
import aboutdinner03 from './Images/about-dinner-tab-03.png';
import aboutdinner04 from './Images/about-dinner-tab-04.png';
import aboutdinner05 from './Images/about-dinner-tab-05.png';

const About = () => {
    const [menu, setMenu] = useState("breakfast");

    const handleMenuChange = (newMenu) => {
        if (newMenu === menu) return;
        setMenu(newMenu);
    };

    const menuImages = {
        breakfast: [
            { id: 1, src: aboutbreakfast01, alt: "Top Image" },
            { id: 2, src: aboutbreakfast02, alt: "Left Image" },
            { id: 3, src: aboutbreakfast03, alt: "Center Image" },
            { id: 4, src: aboutbreakfast04, alt: "Right Image" },
            { id: 5, src: aboutbreakfast05, alt: "Bottom Image" },
        ],
        lunch: [
            { id: 1, src: aboutlunch01, alt: "Top Image" },
            { id: 2, src: aboutlunch02, alt: "Left Image" },
            { id: 3, src: aboutlunch03, alt: "Center Image" },
            { id: 4, src: aboutlunch04, alt: "Right Image" },
            { id: 5, src: aboutlunch05, alt: "Bottom Image" },
        ],
        dinner: [
            { id: 1, src: aboutdinner01, alt: "Top Image" },
            { id: 2, src: aboutdinner02, alt: "Left Image" },
            { id: 3, src: aboutdinner03, alt: "Center Image" },
            { id: 4, src: aboutdinner04, alt: "Right Image" },
            { id: 5, src: aboutdinner05, alt: "Bottom Image" },
        ],
    };

    const menuTexts = {
        breakfast: {
            heading: "Morning Feast",
            paragraph: "Essence of the morning feast—a celebration of flavors, aromas, and nourishment crafted to elevate your day from the very start."
        },
        lunch: {
            heading: "Midday Delights",
            paragraph: "This is a moment when palates are tantalized and cravings find their match. Midday isn't just a time of day; it's an opportunity to savor the culinary treasures that add flavor to our afternoons."
        },
        dinner: {
            heading: "Dining Delights",
            paragraph: "Dining Delights' is not just a mere collection of meals; it's an invitation to embark on a culinary journey filled with exquisite tastes and gastronomic adventures."
        }
    };

    return (
        <div className="about-page-wrapper">
            {/* Immersive Hero Section */}
            <div className="about-hero-section">
                <div className="about-hero-overlay"></div>
                <div className="container about-hero-content">
                    <div className="about-hero-text">
                        <span className="about-badge">About Us</span>
                        <h1 className="tf-heading-lg">Our Story</h1>
                        <p className="about-hero-desc">
                            Sustenance and delight—a journey through culinary landscapes where each dish narrates a unique tale of passion and artistry.
                        </p>
                        <Link to='/Menu_Page'>
                            <button className="tf-btn tf-btn-primary tf-btn-pill about-hero-btn">Explore Menu</button>
                        </Link>
                    </div>
                    <div className="about-hero-image-wrapper">
                        <img className="about-hero-image" src={AboutSectionOneImage} alt="Our Story" />
                    </div>
                </div>
            </div>

            {/* Bento Grid Story Section */}
            <div className="container about-story-section">
                <div className="about-section-header">
                    <span className="about-badge text-center">Heritage</span>
                    <h2 className="tf-heading-md">In 1997, our journey commenced.</h2>
                    <p className="about-section-desc">
                        What began as a humble endeavour has blossomed into a celebration of flavours, an expedition through tastes and traditions.
                    </p>
                </div>

                <div className="about-bento-grid">
                    <div className="about-bento-card bento-tall">
                        <img className="bento-image" src={AboutStoryImageOne} alt="Culinary Preparation" />
                        <div className="bento-overlay"></div>
                    </div>
                    
                    <div className="about-bento-card bento-text-card">
                        <div className="bento-text-content">
                            <h3>Our Triumph</h3>
                            <p>Achievement, and every milestone resonates with the spirit of our journey. Embark with us on this narrative of perseverance and accomplishment, where each chapter unfolds the stories behind our victories and the essence of our unwavering determination.</p>
                            <Link to='/Menu_Page'>
                                <button className="tf-btn tf-btn-outline tf-btn-pill mt-3">Discover Menu</button>
                            </Link>
                        </div>
                    </div>

                    <div className="about-bento-card">
                        <img className="bento-image" src={AboutStoryImageTwo} alt="Fresh Ingredients" />
                    </div>
                    <div className="about-bento-card">
                        <img className="bento-image" src={AboutStoryImageThree} alt="Chef Plating" />
                    </div>
                </div>
            </div>

            {/* Floating Stats Glass Bar */}
            <div className="container">
                <div className="about-stats-glassbar">
                    <div className="stat-item">
                        <h3 className="stat-number">25<span className="stat-accent">+</span></h3>
                        <p className="stat-label">Years of Excellence</p>
                    </div>
                    <div className="stat-item">
                        <h3 className="stat-number">400<span className="stat-accent">+</span></h3>
                        <p className="stat-label">Culinary Varieties</p>
                    </div>
                    <div className="stat-item">
                        <h3 className="stat-number">280<span className="stat-accent">+</span></h3>
                        <p className="stat-label">Locations Explored</p>
                    </div>
                    <div className="stat-item">
                        <h3 className="stat-number">95<span className="stat-accent">%</span></h3>
                        <p className="stat-label">Satisfied Souls</p>
                    </div>
                </div>
            </div>

            {/* Carousel Journey Section */}
            <div className="about-journey-section">
                <div className="container">
                    <div className="about-section-header">
                        <span className="about-badge text-center">Milestones</span>
                        <h2 className="tf-heading-md">Memorable Stops Along Our Journey</h2>
                        <p className="about-section-desc">
                            These stops are not merely destinations but pivotal points that have shaped our narrative, leaving an indelible mark on our collective experience.
                        </p>
                    </div>
                    <div className="about-carousel-wrapper">
                        <AboutSectionThreeCarousel />
                    </div>
                </div>
            </div>

            {/* Interactive Menu Showcase */}
            <div className="about-menu-showcase">
                <div className="container">
                    <div className="about-menu-tabs">
                        {["breakfast", "lunch", "dinner"].map((item) => (
                            <button 
                                key={item}
                                className={`about-menu-tab ${menu === item ? "active" : ""}`}
                                onClick={() => handleMenuChange(item)}
                            >
                                {item.charAt(0).toUpperCase() + item.slice(1)}
                            </button>
                        ))}
                    </div>

                    <div key={menu} className="about-menu-content-wrapper fade-in">
                        <div className="about-menu-visuals">
                            <div className="circular-orbit">
                                {menuImages[menu].map((item, index) => (
                                    <div key={item.id} className={`orbit-circle orbit-pos-${index + 1}`}>
                                        <img src={item.src} alt={item.alt} />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="about-menu-text-panel">
                            <h2 className="tf-heading-md">{menuTexts[menu].heading}</h2>
                            <p className="about-menu-desc">{menuTexts[menu].paragraph}</p>
                            <Link to='/Menu_Page'>
                                <button className="tf-btn tf-btn-primary tf-btn-pill mt-4">Order Now</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Team & Testimonials */}
            <div className="about-components-section">
                <Teams />
                <div className="about-testimonial-spacing">
                    <Testimonial />
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default About;